import React, { useContext } from "react";
import { translate } from "../../../config/translator";
import RoundedRectangle from "../../components/RoundedRectangle";
import mockup from "../../../assets/images/mockupNew.png";
import appPlayStoresLogos from "../../../assets/images/appPlayStoreLogos.png";
import { IOS_STORE_URL } from "../../../config/constants";
import { ClavaContext } from "../../../config/contexts";

const PlayerAppInfo: React.FC = () => {
  const { l } = useContext(ClavaContext);

  return (
    <div className="w-full px-4 mx-auto max-w-6xl xl:max-w-7xl mt-0 mb-12">
      <RoundedRectangle
        className="bg-white dark:bg-bg-secondary-dark overflow-hidden py-4 px-6 xl:py-4 xl:px-10 border border-light-gray dark:border-light-gray-dark w-full"
        hasBorder
        hasTitle={false}
      >
        <div className="flex flex-col md:flex-row items-center gap-6">
          <div className="w-full md:w-1/2 flex justify-center">
            <img
              alt="App"
              title="App"
              src={mockup}
              className="w-full max-w-sm mt-0 mx-auto"
            />
          </div>
          <div className="w-full md:w-1/2 flex flex-col items-center gap-4 text-center">
            <p className="text-base md:text-lg font-medium text-font dark:text-font-dark leading-relaxed max-w-md">
              {translate("playerInfoAppOnly", l)}
            </p>
            <div className="w-full flex items-center justify-center">
              <img
                src={appPlayStoresLogos}
                alt="App Store and Play Store"
                title="App Store and Play Store"
                className="h-6 md:h-5 w-auto"
              />
            </div>
            <div className="w-full flex justify-center">
              <a
                href={IOS_STORE_URL}
                className="rounded-full py-3 px-8 flex flex-row items-center justify-center border-0 bg-primary active:bg-btn-active hover:bg-btn-active text-font-dark"
              >
                <span className="text-sm md:text-base font-semibold px-4 whitespace-nowrap">
                  {translate("downloadNow", l)}
                </span>
              </a>
            </div>
          </div>
        </div>
      </RoundedRectangle>
    </div>
  );
};

export default PlayerAppInfo;


